import { GeneralService } from "./GeneralService";

// TODO: This interface should be generated from the backend AgentAction model
interface AgentAction {
  id?: number;
  date_created?: number;
  agent_id: number;
  action_name: string;
  action_type: string;
  description: string;
  status?: string;
  is_default?: boolean;
  action_result_type?: string;
  action_config?: {
    [k: string]: any;
  };
  meta?: {
    [k: string]: any;
  };
  invocation_mode?: "foreground" | "background";
}

export class AgentActionService {
  
  /**
   * Get all actions for an agent
   */
  static getAgentActions(
    agentId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.get(
      `/agent/agents/${agentId}/actions`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Get action details by ID
   */
  static getAction(
    actionId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.get(
      `/agent/actions/${actionId}`,
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Create a new action for an agent
   */
  static createAgentAction(
    agentId: number,
    action: Partial<AgentAction>,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.post(
      `/agent/agents/${agentId}/actions`,
      JSON.stringify(action),
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Update an action
   */
  static updateAction(
    actionId: number,
    updates: Partial<AgentAction>,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.put(
      `/agent/actions/${actionId}`,
      JSON.stringify(updates),
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Delete an action
   */
  static deleteAction(
    actionId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.delete(
      `/agent/actions/${actionId}`,
      "",
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  /**
   * Set an action as the default for an agent
   */
  static setDefaultAction(
    agentId: number,
    actionId: number,
    setLoading: (loading: boolean) => void,
    apiKey: string
  ) {
    return GeneralService.put(
      `/agent/agents/${agentId}/actions/${actionId}/default`,
      "",
      setLoading,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
} 